import * as React from 'react';
import WebAPINotification from 'components/WebAPINotificationWidget/WebAPINotificationWidget';
import { getAddressFromLatLngAction } from 'actions/addressFromLatLngActions';
import { GeolocationAPI } from 'utils/webAPIHelper';
import { stringTemplate } from 'components/StringWidget/StringWidget';
import withToast from 'components/Toast/withToast';
import { TOAST_LEVELS } from 'components/Toast/Toast';
import styles from './LocationButton.css';
import { LocationIcon } from 'components/Icons/Icons';
import Button from 'components/Button/Button';
import attempt from 'lodash/attempt';
import get from 'lodash/get';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
const geolocationObj = new GeolocationAPI();
class LocationButton extends React.Component {
    constructor(props) {
        super(props);
        this.detectingLocation = () => {
            this.context.modal.hide();
            this.props.onLocatingStarted();
        };
        this.registerPromptCallback = promptCallbackFn => {
            this.promptFunction = promptCallbackFn;
        };
        this.locationDetectionSuccess = (locationData, successCallback, failureCallback) => {
            const { coords } = locationData;
            const { latitude, longitude } = coords;
            this.props.getAddressFromLatLng(latitude, longitude).then(addressLocation => {
                const pincode = get(addressLocation, ['data', 'addressComponents', 0, 'pincode']) || '';
                this.props.onLocationReceived(pincode);
            }, error => this.locationDetectionFailed(error, failureCallback));
            successCallback();
        };
        this.locationDetectionFailed = (error, failureCallback) => {
            if (error === 'undefined' || !error) {
                failureCallback();
            }
            switch (error.code) {
                case error.POSITION_UNAVAILABLE:
                case error.UNKNOWN_ERROR:
                    this.props.toast.show({
                        message: stringTemplate('checkoutInitErrorMsg'),
                        level: TOAST_LEVELS.INFO
                    });
                    break;
                default:
                    failureCallback();
            }
        };
        this.handleAllowLocation = (successCallback, failureCallback) => {
            geolocationObj.getLocation(this.detectingLocation, locationData => this.locationDetectionSuccess(locationData, successCallback, failureCallback), error => this.locationDetectionFailed(error, failureCallback));
        };
        this.handleLocationButtonClick = () => {
            attempt(this.promptFunction, geolocationObj.getPermissionState());
        };
    }
    render() {
        return (<div className={styles['container']}>
				<Button type="button" primary onClick={this.handleLocationButtonClick} className={styles['location-btn']}>
					<LocationIcon className={styles['location-icon']} pathClassName={styles['location-path']}/>
					{stringTemplate('currentLoction')}
				</Button>
				<WebAPINotification onAllow={this.handleAllowLocation} registerPromptCallback={this.registerPromptCallback} promptMessage={stringTemplate('webGeolocationPromptTxt')} reactivateMessage={stringTemplate('webAPIGeolocationText')} overlayMessage={stringTemplate('webAPIGeolocationText')}/>
			</div>);
    }
}
LocationButton.contextTypes = {
    modal: PropTypes.object
};
const mapDispatchToProps = {
    getAddressFromLatLng: getAddressFromLatLngAction
};
export default connect(null, mapDispatchToProps)(withToast(LocationButton));
